import { styled } from '@mui/material';
export const SelectPlaceholder = styled('em')(({ theme }) => ({
    color: theme.palette.text.disabled,
}));
